"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IotStatus = void 0;
var IotStatus;
(function (IotStatus) {
    IotStatus["INITIALIZING"] = "initializing";
    IotStatus["CONNECTED"] = "connected";
    IotStatus["RECONNECTING"] = "reconnecting";
    IotStatus["CLOSED"] = "closed";
    IotStatus["OFFLINE"] = "offline";
    IotStatus["ERROR"] = "error";
})(IotStatus = exports.IotStatus || (exports.IotStatus = {}));
//# sourceMappingURL=IotStatus.js.map